import { animate, state, style, transition, trigger } from "@angular/animations";

export let focus = trigger('focus',[
    state('invisible', style({opacity: '0.1','text-shadow':'none','display':'none'})),
    state('visible', style({opacity: '1','text-shadow': 'currentColor 0 0 1.5em'})),
    transition('invisible <=> visible', animate('0.6s linear'))
  ]);